import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import WhyChooseUs from '../components/WhyChooseUs';
import Modalities from '../components/Modalities';
import Benefits from '../components/Benefits';
import Instructors from '../components/Instructors';
import SocialProof from '../components/SocialProof';
import Gallery from '../components/Gallery';
import Schedule from '../components/Schedule';
import Pricing from '../components/Pricing';
import Beginners from '../components/Beginners';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import InstagramFeed from '../components/InstagramFeed';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { ChevronUp } from 'lucide-react';

const Home = () => {
  const [showScrollTop, setShowScrollTop] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-bg-page">
      <Header />
      <main>
        <HeroSection />
        <WhyChooseUs />
        <Modalities />
        <Benefits />
        <Instructors />
        <SocialProof />
        <Gallery />
        <Schedule />
        <Pricing />
        <Beginners />
        <FAQ />
        <FinalCTA />
        <InstagramFeed />
      </main>
      <Footer />
      
      {/* Utility Buttons Container */}
      <div className="fixed bottom-6 right-6 flex flex-col space-y-4 z-50">
        <button
          onClick={scrollToTop}
          className={`p-4 bg-bg-card border border-white/10 rounded-full text-brand-primary shadow-2xl transition-all duration-500 hover:scale-110 active:scale-95 ${
            showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
          }`}
          aria-label="Voltar ao topo"
        >
          <ChevronUp className="w-6 h-6" />
        </button>
        <WhatsAppButton />
      </div>
    </div>
  );
};

export default Home;
